import { render, staticRenderFns } from "./ViRegisterParentSelf.vue?vue&type=template&id=0707dd22&scoped=true"
import script from "./ViRegisterParentSelf.vue?vue&type=script&lang=js"
export * from "./ViRegisterParentSelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707dd22",
  null
  
)

export default component.exports